import React, { useState, useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import { ButtonUI, DialogUI, FormErrorUI, InputUI } from '../Interface';
import { Box } from '@mui/material';

const NoteDialog = (props) => {
  const [text, setText] = useState('');
  const { open, onClose, noteDialogState } = props;
  const { setFieldValue, errors, values, validateField } = useFormikContext();

  const fieldName = `docLine.${noteDialogState.valueIndex}.bpNote`;

  useEffect(() => {
    if (open) {
      setText(values?.docLine?.[noteDialogState.valueIndex]?.bpNote ?? '');
    }
  }, [open, values, noteDialogState.valueIndex]);

  const handleSave = async () => {
    await setFieldValue(fieldName, text);
    await validateField(fieldName);
    onClose();
  };

  return (
    <DialogUI open={open} onClose={onClose} headerContent="ÜP megjegyzés" maxWidth="md" fullWidth>
      <Box mt="2rem">
        <InputUI
          value={text}
          type="text"
          variant="standard"
          fullWidth
          helperText={<FormErrorUI message={errors?.docLine?.[noteDialogState.valueIndex]?.bpNote} />}
          onChange={(e) => setText(e.target.value ?? '')}
          multiline
          rows={6}
        />
      </Box>

      <Box display="flex" justifyContent="center" gap="0.5rem" mt={2}>
        <ButtonUI text="Mentés" className="bg-success" onClick={handleSave} />
        <ButtonUI text="Mégsem" className="bg-primary" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default NoteDialog;
